/* ==========================================================================
   em-theme.js – merchant customisations (ecommate)
   ========================================================================== */

/* --------------------------------------------------------------------------
   Hide third-party floating widgets while the mini-cart drawer is open.
   App widgets (chat, cookie banner, trust badges, surveys) are injected at
   runtime with unpredictable ids, so they are detected by layout instead of
   by selector: any direct child of <body> that is – or contains – a
   position:fixed layer and does not belong to the theme.
   -------------------------------------------------------------------------- */
(function () {
  var HIDDEN_CLASS = 'em-floating-hidden';
  var RESCAN_DELAYS = [0, 300, 1000, 2500];

  var hiddenElements = [];
  var timers = [];

  var THEME_SELECTOR = '.loading-bar, .skip-to-content, .modal, .drawer, .mini-cart, #main';

  function isThemeElement(element) {
    var id = element.id || '';
    var className = typeof element.className === 'string' ? element.className : '';

    if (id === 'purchase-order-popup' || id.indexOf('purchase-order') !== -1) {
      return true;
    }

    if (id.indexOf('shopify-section') === 0 || className.indexOf('shopify-section') !== -1) {
      return true;
    }

    if (element.matches(THEME_SELECTOR)) {
      return true;
    }

    var miniCart = document.getElementById('mini-cart');
    return Boolean(miniCart) && (element === miniCart || element.contains(miniCart));
  }

  function isFixedLayer(node) {
    if (!node || node.nodeType !== 1) {
      return false;
    }

    var styles = window.getComputedStyle(node);
    return Boolean(styles) && styles.position === 'fixed' && styles.display !== 'none';
  }

  function containsFixedLayer(element) {
    if (isFixedLayer(element)) {
      return true;
    }

    var descendants = element.querySelectorAll('*');
    var limit = Math.min(descendants.length, 80);

    for (var index = 0; index < limit; index++) {
      if (isFixedLayer(descendants[index])) {
        return true;
      }
    }

    return false;
  }

  function hideFloatingWidgets() {
    var children = document.body.children;

    for (var index = 0; index < children.length; index++) {
      var element = children[index];
      var tagName = element.tagName;

      if (tagName === 'SCRIPT' || tagName === 'STYLE' || tagName === 'LINK' || tagName === 'NOSCRIPT' || tagName === 'TEMPLATE' || tagName === 'MAIN') {
        continue;
      }

      if (element.classList.contains(HIDDEN_CLASS) || isThemeElement(element)) {
        continue;
      }

      if (element.querySelector && element.querySelector('#purchase-order-popup')) {
        continue;
      }

      if (containsFixedLayer(element)) {
        element.classList.add(HIDDEN_CLASS);
        hiddenElements.push(element);
      }
    }
  }

  function showFloatingWidgets() {
    timers.forEach(clearTimeout);
    timers = [];

    hiddenElements.forEach(function (element) {
      element.classList.remove(HIDDEN_CLASS);
    });
    hiddenElements = [];
  }

  function onDrawerStateChange() {
    if (document.body.classList.contains('mini-cart-active')) {
      timers.forEach(clearTimeout);
      timers = RESCAN_DELAYS.map(function (delay) {
        return setTimeout(hideFloatingWidgets, delay);
      });
    } else {
      showFloatingWidgets();
    }
  }

  function init() {
    new MutationObserver(onDrawerStateChange).observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    onDrawerStateChange();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* --------------------------------------------------------------------------
   w3apps Purchase Order – one loadApp call when drawer opens / cart updates.
   The app transforms the hidden .save-purchase-order-w3 anchor; no DOM moves.
   -------------------------------------------------------------------------- */
(function () {
  var pendingTimer = null;

  function initPurchaseOrderApp() {
    if (typeof jQuery === 'undefined' || !window.purchaseOrders || !window.purchaseOrders.loadApp) {
      return;
    }

    window.purchaseOrders.loadApp(jQuery);
  }

  function schedulePurchaseOrderApp() {
    clearTimeout(pendingTimer);
    pendingTimer = setTimeout(initPurchaseOrderApp, 200);
  }

  function init() {
    var miniCart = document.getElementById('mini-cart');

    if (!miniCart) {
      return;
    }

    initPurchaseOrderApp();

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'aria-hidden' && miniCart.getAttribute('aria-hidden') === 'false') {
          schedulePurchaseOrderApp();
          break;
        }
      }
    }).observe(miniCart, { attributes: true, attributeFilter: ['aria-hidden'] });

    var headerGroup = document.querySelector('.shopify-section-group-header-group');
    if (headerGroup) {
      headerGroup.addEventListener('cart:rerendered', schedulePurchaseOrderApp);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
